import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
    IonCard,
} from '@ionic/react';
import Header from './Header';
import Footer from './Footer';

const Disclaimer: React.FC = () => {
    return (
        <>
            <IonContent>
                <Header />
                <IonCard className='privacy-policy-section'>
                    <h1 className='text-center font-50'>Disclaimer</h1>
                    <div className='mt-5'>
                        <p>The information provided by <strong>Mama&apos;s Guidance</strong> (&ldquo;we,&ldquo; &ldquo;us,&ldquo; or &ldquo;our&ldquo;) on
                            <a href="https://mamasguidance.com" target="_blank" rel="noreferrer">https://mamasguidance.com</a>
                            (the &ldquo;Site&ldquo;) is for general informational and educational purposes only. All information on the Site is provided in good faith; however, we make <strong>no representation or warranty</strong> of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site.
                        </p>

                        <hr />

                        <h2>Educational Content Disclaimer</h2>
                        <p>
                            The educational resources, worksheets, quizzes, and guidance on this site are intended to support learning and development but should not replace formal education. Parents, teachers, and guardians are encouraged to review materials before use with children.
                        </p>

                        <h2>External Links Disclaimer</h2>
                        <p>
                            The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising.
                            Such <strong>external links are not investigated, monitored, or checked</strong> for accuracy, adequacy, validity, reliability, availability, or completeness by us.
                        </p>
                        <p>
                            We do not <strong>endorse, guarantee, or assume responsibility</strong> for the accuracy or reliability of any information offered by third-party websites linked through the site.
                        </p>

                        <h2>Advertising and Affiliate Disclaimer</h2>
                        <p>
                            Some of the links on this site may be affiliate links. This means we may earn a small commission if you click through and make a purchase, <strong>at no additional cost to you</strong>. This helps us maintain and grow our website.
                        </p>
                        <p>
                            We may also display third-party advertisements through services such as Google AdSense. We are not responsible for the content of those ads or the websites they link to.
                        </p>

                        <h2>Limitation of Liability</h2>
                        <p>
                            Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site.
                            Your <strong>use of the site and your reliance on any information</strong> on the site is solely at your own risk.
                        </p>

                        <h2>Contact Us</h2>
                        <p>
                            If you have any questions regarding this Disclaimer, please contact us:
                        </p>
                        <p>
                            📧 <strong>Email</strong>: <a href="mailto:contact@mamasguidance.com">contact@mamasguidance.com</a>
                        </p>
                    </div>
                </IonCard>
                <Footer />
            </IonContent>
        </>
    );
};

export default Disclaimer;